import React from 'react';
import { useState, useEffect } from 'react';
import TeamsSmallCard from '../components/TeamsSmallCard';

function TeamsPage() {
  const [teamsList, setTeamList] = useState([]);
  const [idLeague, setIdLeague] = useState(39);

  useEffect(() => {
    fetchSearch(idLeague);
  }, [idLeague]);

  const handleDropdownChange = (event) => {
    event === 'Premier League' && setIdLeague(39);
    event === 'La Liga' && setIdLeague(140);
    event === 'Bundes League' && setIdLeague(78);
    event === 'Ligue 1' && setIdLeague(61);
  };

  const fetchSearch = (idLeague) => {
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '42b487df01msh9367a40af1580cap17dd76jsn8040671db253',
        'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com',
      },
    };

    const b = `https://api-football-v1.p.rapidapi.com/v3/standings?season=2022&league=${idLeague}`;
    fetch(b, options)
      .then((response) => response.json())
      .then((response) => {
        setTeamList(response.response[0].league.standings[0]);
      })
      .catch((err) => console.error(err));
  };

  return (
    <section className='mt-28  mx-10   '>
      <div className='md:w-3/6  mx-auto'>
        <div className='w-full flex justify-center'>
          <div className=' w-2/3  lg:max-w-sm  '>
            <select
              onChange={(e) => handleDropdownChange(e.target.value)}
              className='w-full p-2.5 text-gray-500 bg-white border rounded-md shadow-sm outline-none appearance-none focus:border-indigo-600 h-[50px]'
            >
              <option selected>Premier League </option>
              <option>La Liga</option>
              <option>Bundes League </option>
              <option>Ligue 1</option>
            </select>
          </div>
        </div>
      </div>

      <div className='pb-16 mt-11 w-full min-h-[80px] grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
        {teamsList.map((item) => {
          return (
            <TeamsSmallCard
              teamName={item.team.name}
              imgTeam={item.team.logo}
              id={item.team.id}
              idLeague={idLeague}
            />
          );
        })}
      </div>
    </section>
  );
}

export default TeamsPage;
